<template>
	<div class="address">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
			<span v-if="show_delete==false">添加地址</span>
			<span v-else>修改地址</span>
			<div></div>
		</div>
		<van-address-edit @click="ssstt" :show-delete="show_delete" :area-list="areaList" :address-info="addressInfo"
		 show-search-result :area-columns-placeholder="['请选择', '请选择', '请选择']" @save="onSave" @click-area="onchangearea"
		 @delete="onDelete">
			<div style="position:relative">
				<p v-if="show_delete!=false && ssstt==false" class="ssqq">{{ssq.province}}/{{ssq.city}}/{{ssq.area}}</p>
				<van-cell title="是否设置默认">
					<div>
						<van-switch v-model="checked" size="1.3rem" active-color="#f1452f" inactive-color="#d6d6d6" />
					</div>
				</van-cell>
			</div>
		</van-address-edit>
	</div>
</template>

<script>
	import areaList from "@/assets/js/area.js"

	export default {
		data() {
			return {
				areaList,
				searchResult: [],
				checked: false,
				addressInfo: {},
				show_delete: false,
				ssq: "",
				ssstt:false
			}
		},
		created() {
			var id = this.$route.query.id;
			if (id) {
				this.show_delete = true;
				this.$axios.post(baseUrl + '/mobile/User/userUpdateOneAddress', {
					id: id
				}).then((res) => {
					console.log(res.data.data)
					this.ssq = res.data.data
					if (res.data.code == 2) {
						var infoList = {};
						infoList.id = res.data.data.id;
						infoList.name = res.data.data.real_name;
						infoList.tel = res.data.data.phone;
						infoList.province = res.data.data.province;
						infoList.city = res.data.data.city;
						infoList.county = res.data.data.area;
						infoList.addressDetail = res.data.data.address;
						infoList.areaCode = res.data.data.areaCode;
						if (res.data.data.state == 1) {
							this.checked = true;
						} else {
							this.checked = false;
						}
						this.addressInfo = infoList;
					}
				}).catch((err) => {
					console.log(err);
				})
			}
		},
		methods: {
			onSave(content) {
				var message = {};
				if (this.show_delete == true) {
					message.real_name = content.name;
					message.phone = content.tel;
					message.province = content.province;
					message.city = content.city;
					message.area = content.county;
					message.address = content.addressDetail;
					message.areaCode = content.areaCode;
					message.id = this.$route.query.id;
					message.token = localStorage.getItem('Authorization');
					if (this.checked == false) {
						message.state = 0
					} else {
						message.state = 1
					}
					this.$axios.post(baseUrl + '/mobile/User/userUpdateAddress', message).then((res) => {
						if (res.data.code == 7) {
							this.$toast(res.data.msg);
							setTimeout(() => {
								this.back();
							}, 1000)
						}
					}).catch((err) => {
						console.log(err);
					});
				} else {
					message.real_name = content.name;
					message.phone = content.tel;
					message.province = content.province;
					message.city = content.city;
					message.area = content.county;
					message.address = content.addressDetail;
					message.areaCode = content.areaCode;
					message.token = localStorage.getItem('Authorization');
					if (this.checked == false) {
						message.state = 0
					} else {
						message.state = 1
					}
					this.$axios.post(baseUrl + '/mobile/User/userAddAddress', message).then((res) => {
						if (res.data.code == 5) {
							this.$toast(res.data.msg);
							setTimeout(() => {
								this.back();
							}, 1000)
						}
					}).catch((err) => {
						console.log(err);
					});
				}
			},
			onchangearea(content) {
				this.ssstt=true
			},
			onDelete(content) {
				this.$axios.post(baseUrl + '/mobile/User/userDeleteAddress', {
					id: content.id
				}).then((res) => {
					if (res.data.code == 9) {
						this.$toast(res.data.msg)
						setTimeout(() => {
							this.back();
						}, 1000)
					} else {
						this.$toast(res.data.msg)
					}
				}).catch((err) => {
					console.log(err);
				});
			},
		}
	}
</script>

<style scoped>
	.address {
		text-align: left;
		padding-top: 2rem;
	}

	.ssqq {
		font-size: 12px;
		background-color: #fff;
		display: inline-block;
		color: #323233;
		padding: 0.3rem 0.3rem;
		position: absolute;
		top: -5.75rem;
		left: 6.25rem;
		z-index: 999999;
	}
</style>



// WEBPACK FOOTER //
// src/components/address/address.vue